export default "__VITE_ASSET__Ch41M0$N__"